import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './button.css';

export const Button = ({ type = '', href = '/#', children = '', className = '', onClick = () => {} }) => {
    const [fileName, setFileName] = useState(children);
    const uniqueId = Math.random().toString(36).substring(7);
    const navigate = useNavigate();

    const onButtonClick = e => {
        !type?.includes('submit') && e.preventDefault();
        onClick();
        navigate(href);
    };

    const handleFileUpload = event => {
        const fileInput = event.target;
        setFileName(fileInput?.files[0]?.name || children);
    };

    const ButtonSwitch = () => {
        switch (type) {
            case 'submit':
                return (
                    <button type="submit" className={`button ${type} ${className}`} onClick={onButtonClick}>
                        {children}
                    </button>
                );
            case 'attach-file':
                return (
                    <div className="attach-file-wrapper">
                        <label
                            htmlFor={`${uniqueId}`}
                            className={`button attach-file ${fileName !== children && 'file-attached'} ${className}`}
                        >
                            {fileName}
                            <input id={`${uniqueId}`} type="file" onChange={handleFileUpload} />
                        </label>
                    </div>
                );
            default:
                return (
                    <a
                        href={href}
                        className={`button ${type} ${className} ${children && 'has-children'}`}
                        onClick={onButtonClick}
                    >
                        <>
                            <div></div>
                            <span>{children}</span>
                        </>
                    </a>
                );
        }
    };
    return <ButtonSwitch />;
};
